import * as React from 'react'

import type { QuestionTypeId } from '@app/domain/instrument/instrument.interface'
import type { IQuestionLabel, QuestionOption } from '@app/domain/instrument/types'

export interface ResponseHistoryRowTooltipContentProps {
  inputType: QuestionTypeId
  label: IQuestionLabel
  options?: QuestionOption[]
}

export const ResponseHistoryRowTooltipContent = ({
  label,
  options,
  inputType,
}: ResponseHistoryRowTooltipContentProps) => {
  const renderOptions = options.map((option) => {
    const type = ['radio', 'binary'].includes(inputType) ? 'radio' : 'checkbox'
    return (
      <div key={option.label}>
        <label>
          <input type={type} value={type} disabled />
          <span dangerouslySetInnerHTML={{ __html: option.label }} />
        </label>
        <br />
      </div>
    )
  })

  return (
    <>
      <div
        style={{ textAlign: 'left' }}
        dangerouslySetInnerHTML={{ __html: label }}
      />
      <div style={{ textAlign: 'left' }}>{renderOptions}</div>
    </>
  )
}
